if(typeof _GIRL_CONF['emma']['game_memory']=='undefined'){_GIRL_CONF['emma']['game_memory']={};};
_GIRL_CONF['emma']['game_memory']['face']={left:594,top:153,width:130,height:165};
_GIRL_CONF['emma']['game_memory']['hair1']={left:414,top:66,width:292,height:332};
_GIRL_CONF['emma']['game_memory']['hair2']={left:615,top:38,width:208,height:279};
_GIRL_CONF['emma']['game_memory']['hand1']={left:476,top:306,width:315,height:339};
_GIRL_CONF['emma']['game_memory']['hand2']={left:564,top:220,width:100,height:288};
_GIRL_CONF['emma']['game_memory']['item1']={left:186,top:247,width:228,height:438};
_GIRL_CONF['emma']['game_memory']['item2']={left:868,top:370,width:146,height:293};
